var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DsfFormControlBox", {
    staticClass: "ds-upload-file",
    class: { "hide-btns": _vm.hideBtns, "--simple": _vm.simple },
    attrs: { owner: _vm._self },
    scopedSlots: _vm._u([
      {
        key: "simple",
        fn: function () {
          return [
            _c(
              "DsfTextProxy",
              _vm._b(
                {
                  model: {
                    value: _vm.value,
                    callback: function ($$v) {
                      _vm.value = $$v
                    },
                    expression: "value",
                  },
                },
                "DsfTextProxy",
                _vm._self.$props,
                false
              )
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            !_vm.readOnly
              ? [
                  _vm.showMultipleFiles &&
                  _vm.showMultipleFiles.length > 0 &&
                  !_vm.uploadOneFile &&
                  !_vm.simpleFileStyle &&
                  !_vm.hideBtns
                    ? _c(
                        "dsf-button",
                        {
                          staticClass: "download-button",
                          attrs: { icon: "yunduanxiazai" },
                          on: { click: _vm.downLoadAll },
                        },
                        [_vm._v(" 全部下载 ")]
                      )
                    : _vm._e(),
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticClass: "ds-upload-file-bar",
                      class: {
                        "upload-one-file": _vm.uploadOneFile,
                        "simple-file-style": _vm.simpleFileStyle,
                        "has-file-list": _vm.showMultipleFiles.length,
                        "hide-btns": _vm.hideBtns,
                      },
                      attrs: {
                        disabled:
                          _vm.showMultipleFiles.length >= _vm.limit ||
                          _vm.disabled,
                        accept: _vm.acceptMime,
                        multiple: _vm.multiple,
                        drag: _vm.isDragable,
                        limit: _vm.limit,
                        "show-file-list": false,
                        "http-request": _vm.httpRequest,
                        "before-upload": _vm.beforeUpload,
                        "on-exceed": _vm.handleExceed,
                        action: "",
                        "auto-upload": "",
                      },
                    },
                    [
                      _vm.isDragable
                        ? [
                            _c("i", { staticClass: "el-icon-upload" }),
                            _c("div", { staticClass: "el-upload__text" }, [
                              _vm._v("点击上传，或将文件拖拽到此处"),
                            ]),
                          ]
                        : _vm.simpleFileStyle
                        ? [
                            _vm.simple && !_vm.readOnly
                              ? _c(
                                  "dsf-button",
                                  {
                                    attrs: {
                                      "btn-style": "icon-text",
                                      disabled: _vm.disabled,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.showBtnName ? _vm.btnName : ""
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        : _vm.uploadOneFile
                        ? [
                            _c("div", { staticClass: "one-file-button" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.showBtnName ? _vm.btnName : "") +
                                  " "
                              ),
                            ]),
                          ]
                        : [
                            _c(
                              "dsf-button",
                              {
                                attrs: {
                                  disabled:
                                    _vm.showMultipleFiles.length >= _vm.limit ||
                                    _vm.disabled,
                                  icon: "yunduanshangchuan",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.showBtnName ? _vm.btnName : "") +
                                    " "
                                ),
                              ]
                            ),
                          ],
                    ],
                    2
                  ),
                ]
              : _vm._e(),
            _vm.showMultipleFiles.length
              ? [
                  _vm.simple && !_vm.isDesign
                    ? _c(
                        "div",
                        { staticClass: "file-list" },
                        [
                          _vm._l(
                            _vm.showMultipleFiles,
                            function (info, $index) {
                              return [
                                !info.status
                                  ? _c(
                                      "span",
                                      {
                                        key: info.id,
                                        staticClass: "file-item",
                                        attrs: {
                                          title: _vm.getFileTitle(info),
                                        },
                                      },
                                      [
                                        _vm.isFileEncrypt
                                          ? _c("DsfIcon", {
                                              attrs: { name: "suo1" },
                                            })
                                          : _vm._e(),
                                        _c("i", {
                                          staticClass: "icon",
                                          class: info.suffix,
                                        }),
                                        !_vm.clickPreview
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(info.name) +
                                                  "." +
                                                  _vm._s(info.suffix)
                                              ),
                                            ])
                                          : _c(
                                              "span",
                                              {
                                                staticClass: "view-name",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.rowBtClickPreview(
                                                      info,
                                                      $index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(info.name) +
                                                    "." +
                                                    _vm._s(info.suffix)
                                                ),
                                              ]
                                            ),
                                        _c("dsf-icon", {
                                          staticClass: "file-item-bt",
                                          attrs: {
                                            name: "yunduanxiazai",
                                            title: "下载",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.rowBtClickDownload(
                                                info,
                                                $index
                                              )
                                            },
                                          },
                                        }),
                                        !_vm.readOnly
                                          ? _c("dsf-icon", {
                                              staticClass: "file-item-bt",
                                              attrs: {
                                                name: "weitongguo",
                                                title: "删除",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.rowBtClickDelete(
                                                    info
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "span",
                                      {
                                        key: info.id,
                                        staticClass: "file-item --uploading",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "icon",
                                          class: info.suffix,
                                        }),
                                        _c("span", [_vm._v(_vm._s(info.name))]),
                                        !_vm.readOnly
                                          ? _c("dsf-icon", {
                                              staticClass: "file-item-bt",
                                              attrs: {
                                                name: "shanchu1",
                                                title: "删除",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return info.stopHandler.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        info.status.type == "error"
                                          ? _c("dsf-icon", {
                                              staticClass: "file-item-bt",
                                              staticStyle: { color: "#F56C6C" },
                                              attrs: {
                                                name: "icon_refresh",
                                                title: "上传失败，请重新上传",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return info.suspendHandler.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            })
                                          : _c(
                                              "i",
                                              {
                                                staticClass:
                                                  "file-item-progress",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    info.status._progress
                                                  ) + "%"
                                                ),
                                              ]
                                            ),
                                      ],
                                      1
                                    ),
                              ]
                            }
                          ),
                        ],
                        2
                      )
                    : _c(
                        "div",
                        { staticClass: "file-list" },
                        [
                          _c("div", { staticClass: "file-list-row header" }, [
                            _c(
                              "div",
                              { staticClass: "file-list-row-box" },
                              [
                                !_vm.uploadOneFile
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "file-list-col",
                                        staticStyle: { width: "60px" },
                                      },
                                      [_vm._v("序号")]
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass: "file-list-col",
                                    staticStyle: { flex: "auto", width: "0" },
                                  },
                                  [_vm._v("文件名")]
                                ),
                                _vm.showFileDate
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "file-list-multipleFilescol",
                                        staticStyle: { width: "160px" },
                                      },
                                      [_vm._v("上传时间")]
                                    )
                                  : _vm._e(),
                                _vm.showFileSize
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "file-list-col",
                                        staticStyle: { width: "90px" },
                                      },
                                      [_vm._v("文件大小")]
                                    )
                                  : _vm._e(),
                                _vm.isFileEncrypt
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "file-list-col",
                                          staticStyle: { width: "120px" },
                                        },
                                        [_vm._v("密级")]
                                      ),
                                      _vm.editEncryptfileDeadline
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "file-list-col",
                                              staticStyle: { width: "170px" },
                                            },
                                            [_vm._v("解密日期")]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                                _c("div", {
                                  staticClass: "file-list-col _bt _bt1",
                                  style: {
                                    width: _vm.readOnly ? "90px" : "200px",
                                  },
                                }),
                              ],
                              2
                            ),
                          ]),
                          _vm._l(
                            _vm.showMultipleFiles,
                            function (info, $index) {
                              return [
                                !info.status
                                  ? _c(
                                      "div",
                                      {
                                        key: info.id,
                                        staticClass: "file-list-row",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "file-list-row-box" },
                                          [
                                            !_vm.uploadOneFile
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "file-list-col",
                                                    staticStyle: {
                                                      width: "60px",
                                                    },
                                                  },
                                                  [_vm._v(_vm._s($index + 1))]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "file-list-col",
                                                staticStyle: {
                                                  flex: "auto",
                                                  width: "0",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "ds-multi-ellipsis-1",
                                                  },
                                                  [
                                                    _vm.isFileEncrypt
                                                      ? _c("DsfIcon", {
                                                          attrs: {
                                                            name: "suo1",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _c("i", {
                                                      staticClass: "icon",
                                                      class: info.suffix,
                                                    }),
                                                    !_vm.clickPreview
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              info.originalFileName
                                                            )
                                                          ),
                                                        ])
                                                      : _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "view-name",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.rowBtClickPreview(
                                                                  info,
                                                                  $index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                info.originalFileName
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _vm.showFileDate
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "file-list-col",
                                                    staticStyle: {
                                                      width: "160px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm._f("proxy")(
                                                            info.uploadDate,
                                                            _vm.dateFormatter
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.showFileSize
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "file-list-col",
                                                    staticStyle: {
                                                      width: "90px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.computeFileSize(
                                                            info.size
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.isFileEncrypt
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "file-list-col",
                                                      staticStyle: {
                                                        width: "120px",
                                                      },
                                                    },
                                                    [
                                                      info.isNew
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "file-list-col-flex",
                                                            },
                                                            [
                                                              _c(
                                                                "el-select",
                                                                {
                                                                  attrs: {
                                                                    placeholder:
                                                                      "请选择",
                                                                    size:
                                                                      "small",
                                                                  },
                                                                  on: {
                                                                    focus:
                                                                      _vm.handleEncryptFocus,
                                                                    change: function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.securityLevelChange(
                                                                        $event,
                                                                        info
                                                                      )
                                                                    },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      info.securityLevelValue,
                                                                    callback: function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        info,
                                                                        "securityLevelValue",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "info.securityLevelValue",
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.securityLevel,
                                                                  function (
                                                                    item
                                                                  ) {
                                                                    return _c(
                                                                      "el-option",
                                                                      {
                                                                        key:
                                                                          item.value,
                                                                        attrs: {
                                                                          label:
                                                                            item.text,
                                                                          value:
                                                                            item.value,
                                                                        },
                                                                      }
                                                                    )
                                                                  }
                                                                ),
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                info.securityLevelText
                                                              )
                                                            ),
                                                          ]),
                                                    ]
                                                  ),
                                                  _vm.editEncryptfileDeadline
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "file-list-col",
                                                          staticStyle: {
                                                            width: "170px",
                                                          },
                                                        },
                                                        [
                                                          info.securityLevelExpiryDate
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.dsf.date.format(
                                                                      info.securityLevelExpiryDate,
                                                                      "yyyy-mm-dd"
                                                                    )
                                                                  )
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "file-list-col _bt _bt1",
                                                style: {
                                                  width: _vm.readOnly
                                                    ? "90px"
                                                    : "200px",
                                                },
                                              },
                                              [
                                                _vm._l(
                                                  _vm.handleList,
                                                  function (item) {
                                                    return [
                                                      !item.hide ||
                                                      !item.hide(info, $index)
                                                        ? _c("dsf-icon", {
                                                            key: item.id,
                                                            attrs: {
                                                              name: item.icon,
                                                              title: item.name,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return item.hanlder(
                                                                  info,
                                                                  $index
                                                                )
                                                              },
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ]
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          2
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        key: info.id,
                                        staticClass: "file-list-row",
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "file-list-row-progress",
                                          style: {
                                            transform:
                                              "scaleX(" +
                                              info.status.progress / 100 +
                                              ")",
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "file-list-row-box" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "file-list-col",
                                                staticStyle: { width: "60px" },
                                              },
                                              [
                                                info.status.type == "error"
                                                  ? _c("i", {
                                                      staticClass:
                                                        "el-icon-warning-outline",
                                                    })
                                                  : _c("i", {
                                                      staticClass:
                                                        "el-icon-loading",
                                                      class: {
                                                        suspend:
                                                          info.status.type ==
                                                          "suspend",
                                                      },
                                                    }),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "file-list-col",
                                                staticStyle: {
                                                  flex: "auto",
                                                  width: "0",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "ds-multi-ellipsis-1",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "icon",
                                                      class: info.suffix,
                                                    }),
                                                    _vm._v(
                                                      _vm._s(
                                                        info.originalFileName
                                                      ) + " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "file-list-col",
                                                staticStyle: { width: "200px" },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.computeFileSize(
                                                        info.size
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                                info.status.speed
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          opacity: ".8",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "(" +
                                                            _vm._s(
                                                              info.status.speed
                                                            ) +
                                                            ")"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "file-list-col",
                                                staticStyle: {
                                                  width: "90px",
                                                  "text-align": "center",
                                                },
                                              },
                                              [
                                                info.status.type == "suspend"
                                                  ? _c("span", [
                                                      _vm._v("已暂停"),
                                                    ])
                                                  : info.status.type == "error"
                                                  ? _c(
                                                      "el-tooltip",
                                                      {
                                                        attrs: {
                                                          content:
                                                            info.status
                                                              .errorMsg,
                                                          effect: "light",
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "#F56C6C",
                                                            },
                                                          },
                                                          [_vm._v("失败")]
                                                        ),
                                                      ]
                                                    )
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          info.status._progress
                                                        ) + "%"
                                                      ),
                                                    ]),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "file-list-col _bt _bt2",
                                                staticStyle: { width: "120px" },
                                              },
                                              [
                                                _c("dsf-icon", {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        info.status.type ==
                                                        "error",
                                                      expression:
                                                        "info.status.type == 'error'",
                                                    },
                                                  ],
                                                  attrs: {
                                                    name: "icon_refresh",
                                                    title: "重新上传",
                                                  },
                                                  on: {
                                                    click: info.suspendHandler,
                                                  },
                                                }),
                                                _c("dsf-icon", {
                                                  attrs: { name: "weitongguo" },
                                                  on: {
                                                    click: info.stopHandler,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                ]
              : _vm._e(),
            _vm.errors.length > 0 && _vm.showMultipleFiles.length <= 0
              ? _c("div", { staticClass: "ds-error-text" }, [
                  _vm._v(" " + _vm._s(_vm.errorsMsg) + " "),
                ])
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }